/**
 * If string is longer than length, return the string with an ellipsis at the end that with the ellipsis is the target length.
 * @param {String} string
 * @param {number} length
 */
export function clampStringEllipsis(string, length) {
    const ellipsisLength = "...".length;
    if (!string || length <= ellipsisLength) {
        return;
    }

    if (string.length > length) {
        return `${string.substring(0, length - ellipsisLength)}...`;
    } else {
        return string;
    }
}